var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.1,11c1.2-0.3,2.1-1.4,2.1-2.7c0-1.6-1.3-2.8-2.8-2.8c-1.6,0-2.8,1.3-2.8,2.8c0,1.3,0.9,2.4,2.1,2.7 c-2.8,0.3-5.1,2.8-5.1,5.7c0,0.5,0.1,0.9,0.2,1.3c0.1,0.4,0.5,0.6,0.9,0.5c0.4-0.1,0.6-0.5,0.5-0.9C5.1,17.4,5,17,5,16.7 c0-2.4,1.9-4.3,4.3-4.3c2.4,0,4.3,1.9,4.3,4.3c0,0.3,0,0.7-0.1,1c0,0.2,0,0.4,0.1,0.5c0.1,0.2,0.3,0.3,0.4,0.3c0.1,0,0.1,0,0.2,0 c0.1,0,0.3,0,0.4-0.1c0.2-0.1,0.3-0.3,0.3-0.5c0.1-0.4,0.2-0.9,0.2-1.3C15.1,13.8,12.9,11.3,10.1,11z M7.9,8.2 c0-0.8,0.6-1.4,1.4-1.4s1.4,0.6,1.4,1.4c0,0.8-0.6,1.4-1.4,1.4S7.9,9,7.9,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4,11.1c0.9-0.3,1.5-1.2,1.5-2.1c0-1.3-1-2.3-2.3-2.3s-2.3,1-2.3,2.3c0,1,0.6,1.8,1.5,2.1c-0.4,0.1-0.9,0.2-1.3,0.4 c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.4,0,0.6c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.4,0.1,0.6,0c0.5-0.2,0.9-0.3,1.5-0.3 c1.9,0,3.4,1.5,3.4,3.4c0,0.3,0,0.5-0.1,0.8c0,0.2,0,0.4,0.1,0.5c0.1,0.2,0.3,0.3,0.4,0.3c0.1,0,0.1,0,0.2,0c0.1,0,0.3,0,0.4-0.1 c0.2-0.1,0.3-0.3,0.3-0.5c0.1-0.4,0.1-0.7,0.1-1.1C20.4,13.5,18.7,11.5,16.4,11.1z M15.6,8.1c0.5,0,0.8,0.4,0.8,0.8 c0,0.5-0.4,0.8-0.8,0.8c-0.5,0-0.8-0.4-0.8-0.8C14.7,8.5,15.1,8.1,15.6,8.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.9fe6edd47b60ba059a5850160bd00705.svg";
export { ForwardRef as ReactComponent };